export const COMPONENT_NAME = 'BoxOverlayImage';
